import { Component, OnInit } from '@angular/core';
import {QrCodeIn} from '../model/qr-code-in';
import {OrdemServicoService} from '../service/ordem-servico.service';
import {constants} from '../app-constants';
import {DataService} from '../service/data.service';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/api';

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.css']
})

export class QrCodeDialogComponent implements OnInit {
  QRCodeObject = new QrCodeIn();

  constructor(private ordemServicoService: OrdemServicoService,
              public config: DynamicDialogConfig,
              public dialogRef: DynamicDialogRef,
              private data: DataService) {
  }

  status = null;
  ngOnInit() {
    if (this.config.data !== undefined) {
      this.status = JSON.parse(this.config.data);
    }
  }

  onFileChanged(event) {
    const file = event.files[0];
    const fileReader = new FileReader();

    fileReader.onload = function (fileLoaderEvent) {
      const srcData = fileLoaderEvent.target as FileReader;
      const img = document.getElementById('outputTemp') as HTMLImageElement;
      img.src = srcData.result.toString();
    };
    fileReader.readAsDataURL(file);
  }

  onUpload() {
    const image = document.getElementById('outputTemp') as HTMLImageElement;
    this.QRCodeObject.imageInBase64 = image.src;
    const cliente = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.QRCodeObject.contratoId = cliente.clienteContratoId;
    if (this.status != null) {
      this.QRCodeObject.listStatusOs = this.status;
      this.ordemServicoService.buscarAtivoQRCode(this.QRCodeObject).subscribe( response => {
        if (response.sucesso === false) {
          alert('Houve um erro ao processar seu QR Code');
          console.log(response.erros);
        } else {
          this.processaOrdemServicoOut(response.ordemServicoOut);
        }
      });
    } else {
      this.ordemServicoService.buscarAtivoQRCodeNovaOS(this.QRCodeObject).subscribe(response => {
        this.processaAtivoOut(response.ativosOut);
      });
    }

  }

  processaOrdemServicoOut (ordemServicoOut) {
    if (ordemServicoOut == null) {
      alert('Não foram achadas ordens de serviço com esse ativo');
    } else {
      if (this.status.length > 1) {
        this.data.changeMessage('aberta');
      } else {
        this.data.changeMessage('fechada');
      }
      this.data.changeMessage(JSON.stringify(ordemServicoOut));
      this.dialogRef.close();
    }
  }

  processaAtivoOut (ativoOut) {
    if (ativoOut == null) {
      alert('Não foram achados ativos com ess QR Code');
    } else {
      this.data.changeMessage('criar-os');
      this.data.changeMessage(JSON.stringify(ativoOut));
      this.dialogRef.close();
    }
  }
}
